export default class DtoReadFileParams {
    constructor(obj = {}) {
        this.nbCols = obj.nbCols // Option[Int]
        this.dateFormat = obj.dateFormat // Option[String]
        this.hasHeader = obj.hasHeader // Option[Boolean]
        this.nbHeaders = obj.nbHeaders // Option[Int]
        this.sheet = obj.sheet // Option[String]
        this.excludedValue = obj.excludedValue // Option[String]
        this.commaSeparator = obj.commaSeparator // Option[Boolean]
        this.semicolonSeparator = obj.semicolonSeparator // Option[Boolean]
        this.tabulationSeparator = obj.tabulationSeparator // Option[Boolean]
        this.spaceSeparator = obj.spaceSeparator // Option[Boolean]
        this.customSeparator = obj.customSeparator // Option[String]
    }
}
